import { z } from 'zod'

export const inviteSchema = z.object({
  token: z.string(),
  createdAt: z.string(),
  userIdLock: z.string().nullable(),
  emailLock: z.string().nullable(),
  useCount: z.number(),
})

export type Invite = z.infer<typeof inviteSchema>
